
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mypage/NFT",
      function () {
        return require("private-next-pages/mypage/NFT.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mypage/NFT"])
      });
    }
  